import ko from "knockout";
import ViewModel from "viewModels/ViewModel";
import EvaluationSummaryView from "viewModels/EvaluationSummaryView";
import SurveySummaryView from "viewModels/SurveySummaryView";
import qualityAuth from "services/qualityAuth";

const QualitySummaryView = ViewModel.extend(function (
    conversationId,
    hasParticipantToEvaluate,
    deleteEvaluationCallback
) {
    const self = this;

    self.evaluationSummaryView = ko.observable();
    if (
        qualityAuth.canAddEvaluation() ||
        qualityAuth.canDeleteEvaluation() ||
        qualityAuth.canAddCalibration()
    ) {
        self.evaluationSummaryView(
            self.subView(
                EvaluationSummaryView,
                conversationId,
                hasParticipantToEvaluate,
                deleteEvaluationCallback
            )
        );
    }

    self.surveySummaryView = ko.observable();
    if (qualityAuth.canViewSurvey()) {
        self.surveySummaryView(self.subView(SurveySummaryView, conversationId));
    }
});

export default QualitySummaryView;
